<template>
  <app-layout>

    <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-2"
         role="alert">
      <p class="text-yellow-700 font-bold">Tips:</p>
      <p class="text-gray-400 font-bold text-lg">Using this tool to pick a person for something or select a random option.</p>
    </div>
    <lucky-shuffle :cards="cards"></lucky-shuffle>
  </app-layout>

</template>

<script>
import {computed, onMounted, defineComponent, ref} from 'vue';
import AppLayout from "@/Layouts/AppLayout";
import LuckyShuffle from "@/Pages/LuckyShuffle/LuckyShuffle";

export default {
  setup(props) {

    return {}
  },
  mounted() {
  },
  data() {
    return {
      cards: []
    }
  },
  created() {
  },

  watch: {},
  methods: {},
  components: {LuckyShuffle, AppLayout},
}
</script>

<style scoped>


.shuffleSlow-move {
  transition: transform 2s;
}

.shuffleMedium-move {
  transition: transform 1s;
}

.shuffleFast-move {
  transition: transform 0.5s;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>